import React from 'react';
import { Button, Grid } from '../../common';
import StandardModal from '../../common/modals/StandardModal';

export interface TrashcanModalProps {
	onDelete: () => any;
	onRemove: () => any;
    onClose: () => any;
}

const TrashcanModal = (trashcanModalProps: TrashcanModalProps) => {
    return (
		<StandardModal
			show={true}
			onDismiss={trashcanModalProps.onClose}
			title="Delete/Remove Rule"
			footer={
				<Grid variant="2up">
					<Grid.Item>
						<Button variant="primary" onClick={trashcanModalProps.onDelete}>
							DELETE FROM SUBSCRIPTION
						</Button>
					</Grid.Item>
					<Grid.Item>
						<Button variant="secondary" onClick={trashcanModalProps.onRemove} optionalClass={"em-c-btn--accent"}>
							REMOVE FROM REQUEST
						</Button>
					</Grid.Item>
				</Grid>
			}
		>
			You can:
			<ul style={{ listStyleType: 'disc', marginLeft: 30 }}>
				<li><b>DELETE</b> the rule from the subscription</li>
				<li><b>REMOVE</b> the rule from the grid</li>
			</ul>
		</StandardModal>
    );
}

export default TrashcanModal;